import { render, staticRenderFns } from "./CadastreBuildingConstructiveFieldEditModal.vue?vue&type=template&id=fb5dbad2&scoped=true&"
import script from "./CadastreBuildingConstructiveFieldEditModal.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingConstructiveFieldEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5dbad2",
  null
  
)

export default component.exports